import React from 'react';
import { ColorValue, GestureResponderEvent, PressableProps } from 'react-native';
import { LabelType } from '../common/Label';
import { faCircleChevronLeft } from '@fortawesome/free-solid-svg-icons';
import NavigationButton from '../common/NavigationButton';
import { useNavigation } from '@react-navigation/native';
import type { MyAccountRouteName } from '../../models/NavigationElements';

export interface MyAccountNavigationButtonProps extends PressableProps {
  title: string;
  action?: MyAccountRouteName;
  iconColor?: ColorValue;
  navigationTitleColor?: ColorValue;
}

const MyAccountNavigationButton = (props: MyAccountNavigationButtonProps) => {
  const navigation = useNavigation();

  const onPressHandle = (e: GestureResponderEvent) => {
    if (props.action) {
      // Use pop when possible so the transition runs in the "back" direction.
      if (navigation.canGoBack()) {
        navigation.goBack();
      } else {
        navigation.navigate(props.action as never);
      }
    }

    if (props.onPress) {
      props.onPress(e);
    }
  };

  return (
    <NavigationButton
      icon={faCircleChevronLeft}
      iconSize={24}
      iconColor={props.iconColor}
      labelVariant={LabelType.titleSmall}
      onPress={(e) => {
        onPressHandle(e);
      }}
      text={props.title}
      color={props.navigationTitleColor}
    />
  );
};

export default MyAccountNavigationButton;
